import { render } from "./Cleaning.vue?vue&type=template&id=28fb7c34&scoped=true"
import script from "./Cleaning.vue?vue&type=script&lang=js"
export * from "./Cleaning.vue?vue&type=script&lang=js"

import "./Cleaning.vue?vue&type=style&index=0&id=28fb7c34&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28fb7c34"]])

export default __exports__